/**
 * Replaces svgcanvas's `$click` with one that listens for `click` only.
 *
 * The original registers its handler on BOTH `click` and `touchend`. A mouse never fires touchend, so on
 * a desktop that is invisible; a tap on a touch screen fires both, and every toolbar button did its job
 * twice. Clone made two copies, undo undid two steps — and Ungroup, the worst case: the first firing
 * dissolved the group and hid the button, the toolbar re-laid-out, and the second event landed on whatever
 * had moved under the finger, which was Clone.
 *
 * `touchend` was there for the days a click waited 300 ms for a possible double-tap. A page with a
 * `width=device-width` viewport (ours has one) no longer waits, so `click` alone is prompt on a phone.
 *
 * Every consumer — the panels, MainMenu, EditorStartup, the `se-*` components through `svgEditor.$click`,
 * and the extensions — takes `$click` from the `SvgCanvas` static when its module is evaluated, so this
 * has to run before them: Editor.js imports it first.
 */
import SvgCanvas from '@svgedit/svgcanvas'

SvgCanvas.$click = (element, handler) => {
  element.addEventListener('click', handler)
}
